import {
  Iis,
  IList,
  promiseState,
  WithPromiseState
} from 'annotation-tools/utils';
import { FetchListErrorReasonType } from './error-reason-type';

export type ListUnresolvedValue<T> = { latest: IList<T> };
export type ListErrorValue<T> = {
  latest: IList<T>;
  reason: FetchListErrorReasonType;
};
export type ListSuccessValue<T> = { latest: IList<T> };

export type ListWithPromiseState<T> = WithPromiseState<
  ListUnresolvedValue<T>,
  ListErrorValue<T>,
  ListSuccessValue<T>
>;

export const listWithPromiseStateInit = <T>(): ListWithPromiseState<T> => ({
  value: { latest: IList<T>() },
  status: promiseState.pending
});

export const listWithPromiseStateEq = <A, B>(
  a: ListWithPromiseState<A>,
  b: ListWithPromiseState<B>
): boolean =>
  a.status === b.status &&
  Iis(a.value.latest, b.value.latest) &&
  a.status !== 'error'; // if status is "error" -> define as a !== b
